module.exports = __webpack_public_path__ + "img/file_docx.1af7f633.svg";